module.exports = __webpack_public_path__ + "media/excellusbcbs-wordpress-feed@md-5e7a6cebddba26d1d6ef7dd8ff047fba.jpg";